import type React from "react";
import { motion } from "framer-motion";
import { FcGoogle } from "react-icons/fc";
import { Divider, Fleuron, Monogram } from "../Ornament";
import { easeManor } from "../../constants/constants";
import { useAuth } from "../../lib/auth";

const SignIn: React.FC<{ notAdmin?: boolean; email?: string | null }> = ({
  notAdmin,
  email,
}) => {
  const { signInWithGoogle, signOut, configured } = useAuth();
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease: easeManor }}
      className="card-parchment relative max-w-md w-full mx-auto px-10 py-14 rounded-sm"
    >
      <div className="absolute inset-3 border border-[color:var(--gilt-hairline)] pointer-events-none" />
      <div className="absolute top-4 left-1/2 -translate-x-1/2 text-[color:var(--gilt-deep)]">
        <Fleuron className="w-12 h-3" />
      </div>
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-[color:var(--gilt-deep)]">
        <Fleuron className="w-12 h-3" />
      </div>

      <div className="text-center">
        <Monogram className="text-4xl" />
        <p className="mt-6 u-label">
          {notAdmin ? "Access Restricted" : "Private Chambers"}
        </p>
        <h2 className="mt-4 font-display text-4xl text-[color:var(--claret-deep)]">
          {notAdmin ? (
            <>
              Not on the <em>guest list</em>.
            </>
          ) : (
            <>
              Please <em>identify</em> yourself.
            </>
          )}
        </h2>

        <div className="mt-8">
          <Divider />
        </div>

        {notAdmin ? (
          <>
            <p className="mt-8 text-[color:var(--ink-soft)] leading-relaxed">
              You are signed in as{" "}
              <span className="italic text-[color:var(--claret)]">{email}</span>,
              which is not an admin of Moyle Manor. If you believe this is in
              error, please reach out to Matthew or Kimberly.
            </p>
            <div className="mt-8">
              <button type="button" onClick={signOut} className="btn-ghost">
                Sign out
              </button>
            </div>
          </>
        ) : (
          <>
            <p className="mt-8 text-[color:var(--ink-soft)] leading-relaxed">
              This wing of the house is reserved for the proprietors. Sign in
              with the Google account on your invitation.
            </p>
            <div className="mt-8">
              <button
                type="button"
                onClick={signInWithGoogle}
                disabled={!configured}
                className="btn-seal disabled:opacity-60 disabled:cursor-not-allowed"
                style={{ background: "var(--parchment)", color: "var(--claret-deep)", border: "1px solid var(--gilt-deep)" }}
              >
                <FcGoogle size={18} />
                <span>Continue with Google</span>
              </button>
            </div>
            {!configured && (
              <p className="mt-6 u-label text-[color:var(--claret)]">
                Supabase not configured — see SETUP.md
              </p>
            )}
          </>
        )}
      </div>
    </motion.div>
  );
};

export default SignIn;
